export const TREATMENT = 'treatment'
export const CONTROL = 'control'
export const EXPERIMENT_SESSION_STORAGE_KEY = 'experiment_storage_key'
export const PREMIUM_PAGE_TEST = 'premium-page-test'
export const LANDINGS_CONTROL_TEST = 'landings-control-test'
export const ADS_DETAILS_VIEW = 'ads-details-view'
export const LANDINGS_CTA_TEXT_MAB_TEST = 'landings-cta-text-mab-test'
export const ADS_SEARCH_CLASSIC_TEST = 'ads-classic-early-access'
